import SocketIO, { Socket } from 'socket.io-client';
import qs from 'qs';
import { SOCKET_URL } from '../config/secrets';
import { ROOM_NAMESPACE_SUFFIX } from '../common/constants/socket-events';
import Reasons from '../common/constants/reasons';
import PermissionService from './permission-service';
import Roles from '../common/constants/roles';

const qsData = qs.parse(window.location.search, { ignoreQueryPrefix: true });

type OnArgsType = [string, (data?: any, fn?: () => any) => any];
type OffArgsType = [string, Function];

export class SocketService {
  private _socket: typeof Socket;
  constructor(url: string, options?: SocketIOClient.ConnectOpts) {
    this._socket = SocketIO(url, options);

    this.on('error', (data: any) => console.error('socket error: ', data));
  }

  on = (...args: OnArgsType) => this._socket.on(...args);

  off = (...args: OffArgsType) => this._socket.off(...args);

  offAll = () => this._socket.removeAllListeners();

  emit = (event: string, data = {}, ...args: any[]) => {
    return this._socket.emit(event, data, ...args);
  };

  emitAsync = (event: string, data?: any) =>
    new Promise<any>((resolve, reject) => {
      return this.emit(event, data, (data: any) => {
        if (!data?.success) {
          return reject(data);
        }

        return resolve(data);
      });
    });

  getSocket() {
    return this._socket;
  }
}

export default abstract class {
  private static instance: SocketService | undefined;

  static getInstance() {
    if (this.instance) {
      return this.instance;
    }

    this.instance = new SocketService(`${SOCKET_URL}/${ROOM_NAMESPACE_SUFFIX}${qsData.socket_room}`, {
      path: '/wsapi',
      transports: ['polling', 'websocket'],
      query: {
        'x-jwt-token': window.authToken || '',
        'x-connect-reason': PermissionService.hasRoles([Roles.ROLE_PRESENTER])
          ? Reasons.CONTROL_VIEWER
          : Reasons.SUBSCRIBE_UPDATES,
      },
    });

    return this.instance;
  }

  static removeActiveInstance() {
    if (this.instance) {
      this.instance.offAll();
      this.instance.getSocket().close();
      delete this.instance;
    }
  }
}
